var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChessBlackP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 644 843",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-178,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chess_blackP",
    d: "M500.074,93.112C395.885,95.038 296.497,178.248 297.548,301.406C298.807,448.934 413.564,497.7 421.776,500C416.84,578.433 359.175,776.366 246.777,774.41C183.819,789.962 194.498,887.002 250.966,885.04C283.432,883.913 718.233,883.517 754.778,883.517C806.522,879.448 818.127,779.34 741.127,775.282C691.161,773.241 613.151,725.04 581.851,500C683.171,472.659 704.524,334.447 706.073,302.137C710.309,213.8 656.124,90.228 500.074,93.112Z",
    style: {
      stroke: "black",
      strokeWidth: 50
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessBlackP);
export default __webpack_public_path__ + "static/media/chess_blackP.83ddb2f301afed3a8c10a122ea0c4ae7.svg";
export { ForwardRef as ReactComponent };